<template>
    <Audit v-if="openModal" @close="openModal = false" :open="openModal" :activity_logs="currentInvoice.activity_logs" />
    <div class="table-container">
        <table class="min-w-full table-fixed">
            <thead class="bg-gray-50">
                <tr>
                    <th scope="col" class="w-2/12 text-left px-3 py-3 text-xs text-gray-500 uppercase tracking-wider">Reference</th>
                    <th scope="col" class="w-1/12 text-left px-3 py-3 text-xs text-gray-500 uppercase tracking-wider" v-if="display_related_quotes">Quote</th>
                    <th scope="col" class="w-1/12 text-left px-3 py-3 text-xs text-gray-500 uppercase tracking-wider">Date Raised</th>
                    <th scope="col" class="w-1/12 text-left px-3 py-3 text-xs text-gray-500 uppercase tracking-wider">Date Due</th>
                    <th scope="col" class="w-1/12 text-left px-3 py-3 text-xs text-gray-500 uppercase tracking-wider">Amount</th>
                    <th scope="col" class="w-1/12 text-left px-3 py-3 text-xs text-gray-500 uppercase tracking-wider">Paid</th>
                    <th scope="col" class="w-1/12 text-left px-3 py-3 text-xs text-gray-500 uppercase tracking-wider">Amount Paid</th>
                    <th scope="col" class="w-1/12 text-left px-3 py-3 text-xs text-gray-500 uppercase tracking-wider">Final</th>
                    <th scope="col" class="w-1/12 text-left px-3 py-3 text-xs text-gray-500 uppercase tracking-wider">Status</th>
                    <th scope="col" class="w-1/12 text-left px-3 py-3 text-xs text-gray-500 uppercase tracking-wider">Actions</th>
                    <th scope="col" class="w-1/12 text-left px-3 py-3 text-xs text-gray-500 uppercase tracking-wider"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-if="invoices.length > 0" v-for="(invoice, index) in invoices" :key="index" :class="{'bg-gray-100': index % 2}" class="hover:bg-gray-50 cursor-pointer">
                    <td class="px-3 py-3 text-xs uppercase tracking-wider truncate font-bold">{{ invoice.reference }}</td>
                    <td class="px-3 py-3 text-sm text-gray-900" v-if="display_related_quotes && invoice.quote">{{ invoice.quote.name }}</td>
                    <td class="px-3 py-3 text-sm text-gray-900">{{ invoice.invoiced_at }}</td>
                    <td class="px-3 py-3 text-sm text-gray-900">{{ invoice.due_at }}</td>
                    <td class="px-3 py-3 text-sm text-gray-900" v-if="this.invoice_type == 'Invoice'">{{ formatCurrency(invoice.deposit_total, project.bank_account.currency.code, true) }}</td>
                    <td class="px-3 py-3 text-sm text-gray-900" v-else>{{ formatCurrency(invoice.amount, project.bank_account.currency.code, true) }}</td>
                    <td class="px-3 py-3 text-sm text-gray-900"><CheckIcon class="text-green-600 w-6 h-6" v-if="invoice.is_paid" /></td>
                    <td class="px-3 py-3 text-sm text-gray-900">{{ formatCurrency(invoice.amount_paid ?? 0, project.bank_account.currency.code, true) }}</td>
                    <td class="px-3 py-3 text-sm text-gray-900"><CheckIcon class="text-green-600 w-6 h-6" v-if="invoice.is_final" /></td>
                    <td class="px-3 py-3 text-sm text-gray-900">
                        <span v-if="invoice.status === 'Sent'" class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium shadow-md bg-gray-500 text-white">{{ invoice.status }}</span>
                        <span v-if="invoice.status === 'Cancelled'" class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium shadow-md bg-red-500 text-white">{{ invoice.status }}</span>
                        <span v-if="invoice.status === 'Paid'" class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium shadow-md bg-green-100 text-green-800">{{ invoice.status }}</span>
                    </td>
                    <td class="px-3 py-3 text-sm text-gray-900">
                        <a v-if="(invoice.status === 'Sent' && invoice.is_paid === 0 && invoice.is_credit_note === false)"
                        class="flex gap-1 items-center cursor-pointer"
                        @click="cancelInvoice(invoice)"
                        title="Cancel Invoice / Create Credit Note">
                            <CreditCardIcon class="w-4 h-4" /> Cancel Invoice / CR
                        </a>
                        <a class="flex gap-1 items-center cursor-pointer"
                        :href="downloadInvoice(invoice)"
                        title="Download Invoice">
                            <DocumentDownloadIcon class="w-4 h-4" />
                            <span>Download</span>
                        </a>
                        <a v-if="this.invoice_type == 'Commission'"
                        class="flex gap-1 items-center cursor-pointer"
                        @click="invoiceInternalNotes(invoice)"
                        title="View Internal Notes">
                            <PencilIcon class="w-4 h-4" />
                            <span>View Notes</span>
                        </a>
                        <a v-if="(invoice.amount_paid === 0 && this.invoice_type == 'Commission' )"
                        class="flex gap-1 items-center cursor-pointer"
                        @click="cancelInvoice(invoice)"
                        title="Cancel Invoice / Create Credit Note">
                            <CreditCardIcon class="w-4 h-4" />
                            Cancel Invoice / CR
                        </a>
                    </td>
                    <td class="px-3 py-3 text-sm text-gray-900">
                        <button type="button" @click="currentInvoice = invoice, openModal = true"
                            class="col-span-2 items-center px-3 py-2 border border-transparent shadow-sm text-sm leading-4 rounded-md text-white bg-amaze-coral focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black">
                            Show Changelog
                        </button>
                    </td>
                </tr>
                <tr v-else>
                    <td colspan="10" class="px-3 py-3 text-xs text-gray-500 uppercase tracking-wider">There are no invoices to display.</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import {
  CheckIcon,
  NewspaperIcon,
  CreditCardIcon,
  PencilAltIcon,
  InboxIcon,
    PlusSmIcon,
    DocumentDownloadIcon,
    PencilIcon
} from "@heroicons/vue/outline"

import {emitter} from "@/eventHub";
import {usePage} from "@inertiajs/vue3";

import collect from 'collect.js';
import { ref } from "vue";

import Audit from "@/Components/Modal/Audit.vue";

export default {
    components: {
        CheckIcon,
        NewspaperIcon,
        CreditCardIcon,
        PencilAltIcon,
        InboxIcon,
        PlusSmIcon,
        DocumentDownloadIcon,
        PencilIcon,
        Audit
    },
    props: {
        invoices: Object,
        display_related_quotes: {type: Boolean, default: false},
        invoice_type: {type: String, default: "Invoice"},
        project: Object
    },
    setup(){
        const openModal = ref(false);
        const currentInvoice = ref(null);

        return {openModal, currentInvoice};
    },
    data() {
        return {
            emitter:emitter,
            showErrors: false,
        }
    },
    created() {
    },
    methods: {
        collect,
        /**
         * Cancels a specified invoice
         */
        cancelInvoice (invoice) {
            // build the url depending on the invoice type
            var url = '';

            console.log(this.invoice_type);

            switch(this.invoice_type) {
                case 'Management Fee':
                    url = route('frontend.management-fees.cancel', [invoice.id]);
                    break;
                case 'Invoice':
                    url = route('frontend.invoices.cancel', [invoice.id]);
                    break
                case 'Commission':
                    url = route('frontend.project.commission.cancel', [usePage().props.project.id, invoice.id]);
                    break
            }

            this.$swal.fire({
                title: 'Cancel Invoice',
                html: "You are cancelling an invoice. <br/>Are you sure you'd like to do this?",
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No'
                }).then((result) => {
                    if (result.isConfirmed) {
                        // Delete the invoice
                        this.$inertia.get(url, {preserveScroll: true});
                    }
            });
        },
        /**
         * Generates the download URL for an invoice
         */
        downloadInvoice (invoice) {
            // build the url depending on the invoice type
            var url = '';

            switch(this.invoice_type) {
                case 'Management Fee':
                    url = route('frontend.management-fees.download', [invoice.id]);
                    break;
                case 'Invoice':
                    url = route('frontend.invoices.download', [invoice.id])
                    break
                case 'Commission':
                    url = route('frontend.project.commission.download', [usePage().props.project.id, invoice.id])
                    break
            }

            return url;
        },
        /**
         * View the internal notes of a commission invoice
         */
        invoiceInternalNotes(invoice) {
            this.$swal.fire({
                title: 'Internal Notes',
                html: invoice.internal_notes,
                showCloseButton: true,
                showCancelButton: false,
            });
        }
    }
}
</script>
<style lang="scss" scoped>
.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
